export default __webpack_public_path__ + "static/media/xero_desktop.65f06f6d.png";